//
// Module for File Exports supplemental views and logic
//
rs.module("content/system_/activity/fileexports/supplemental",

    [],

    function () {

        // Initialize the module
        function initialize(jsSelectors) {

            var modalForm = $.js(jsSelectors.modalForm);

            var fileKeyHiddenField = modalForm.js(jsSelectors.fileKeyHiddenField);

            var modalPopup = modalForm.js(jsSelectors.modalPopup);
            var modalPopupCancelButton = modalPopup.js(jsSelectors.modalPopupCancelButton, { multiple: true });
            var modalConfirmationMessage = modalPopup.js(jsSelectors.modalConfirmationMessage);

            // Display the modal popup
            $(document).onjs('click', jsSelectors.transferLink, function () {
                fileKeyHiddenField.val($(this).data("route-key"));
                var fileName = $(this).data("route-name");

                modalConfirmationMessage.html(`Are you sure you want to transfer ${fileName}?`);

                modalPopup.modal('show');
                return false;
            })
    
            // Handle the modal 'Close' button event.
            modalPopupCancelButton.click(function () {
                modalPopup.modal('hide');
                return false;
            });
        }

        // Callback function to perform after grid update is complete 
        function onGridUpdateComplete(gridUpdateResult, agGridApi) {

            var isEligibleForFtp = gridUpdateResult.context.isEligibleForFtp;
            var transferStatusGridColId = gridUpdateResult.context.transferStatusGridColId;

            // Show or hide the Transfer Status grid column based on the selected repository being eligible for FTP
            agGridApi.setColumnsVisible([transferStatusGridColId], isEligibleForFtp);     
        }

        // Exported public API
        var exports = {
            initialize: initialize,
            onGridUpdateComplete: onGridUpdateComplete
        };

        return exports;
    }
);